<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row>
                <b-col>                                                 
<!--                    <h1>-->
<!--                        Manage Events-->
<!--                    </h1>-->

                    <b-row>
                        <b-col md="6">
                            <b-button variant="outline-primary mt-1 tb-button tb-button--blue font-thin create-new" to="/admin/events/create">
                                Create New Event
                            </b-button>
                        </b-col>

                        <b-col md="6">
                            <b-input-group class="mt-3 mt-md-1">
                                <b-form-input v-model="filter" placeholder="Type to search" class="tb-form-field tb-form-field--large" />
                                <b-input-group-append>
                                    <b-button :disabled="!filter" @click="filter = ''" class="tb-clear-button">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row>

                    <b-table class="mt-3 tb-table"
                        stacked="md"
                        :filter="filter"
                        :items="events"
                        :fields="fields"
                        :sort-by="'client_name'">

                        <template slot="actions" slot-scope="row">
                            <b-button class="btn-info mr-2 tb-table__button tb-table__button--gold" :to="{ name: 'edit-event', params: { id: row.item.id } }">
                                Edit
                            </b-button>

                            <b-button class="btn-danger tb-table__button tb-table__button--blue" @click="askDeleteItem(row.item)">
                                Delete
                            </b-button>

                            <b-button class="tb-table__button tb-table__button--gold" @click.prevent="duplicateItem(row.item.id)">
                                <span class="inline-fa">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"/></svg>
                                </span>
                            </b-button>
                        </template>
                    </b-table>

                    <b-modal 
                        v-model="show_delete_modal"
                        id="delete-modal"
                        title="Warning"
                        @ok="deleteItem()"
                        header-bg-variant="danger"
                        header-text-variant="light"
                        ok-title="Delete"
                        ok-variant="danger">
                        Are you sure you want to permanently delete this event?
                    </b-modal>
                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>
</template>

<script>
    import eventRepository from "@/repository/events"

    export default {
        data() {
            return {
                fields: [
                    {
                        label: "Client",
                        key: 'client_name',
                        sortable: true
                    },
                    {
                        label: "Name",
                        key: 'name',
                        sortable: true
                    },
                    'actions'
                ],
                show_delete_modal: false,
                event_to_delete: null,
                filter: "",
                loaded:false,
                events:[],
            }
        },

        methods: {
            askDeleteItem(item) {
                this.show_delete_modal = true;
                this.event_to_delete = item;
            },
            
            deleteItem() {
                eventRepository.destroy(this.event_to_delete.id)
                    // eslint-disable-next-line no-unused-vars
                    .then(response => {
                        let id = this.events.findIndex(event => event.id == this.event_to_delete.id);
                        this.events.splice(id, 1);

                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Event Deleted',
                            text: 'Event successfully deleted.'
                        });
                    })
            },

            duplicateItem(id) {
                eventRepository.duplicate(id)
                    .then(response => {
                        // console.log(response);
                        let event = response.data[0];
                        event.client_name = event.client.name;
                        this.events.push(event);

                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Event Duplicated',
                            text: 'Event successfully duplicated.'
                        });
                    });
            }
        },

        mounted() {
            eventRepository.getAll({
                include: 'client'
            }).then(res => {
                res.data.forEach(e => {
                    if (e.client !== null) e.client_name = e.client.name;
                    this.events.push(e);
                });
                this.loaded = true;
            });
        }
    }
</script>

<style scoped lang="scss">

</style>